import { createSlice } from "@reduxjs/toolkit";
import VwKurumbonustanimdetayDTO from "src/models/KurumBonusTanim/VwKurumbonustanimdetayDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";

interface IKurumBonusTanimlariTestBazli {
    iptalGosterme: string;
    activeRow: VwKurumbonustanimdetayDTO;
    open: boolean;
};

export const kurumBonusTanimlariTestBazliSlice = createSlice<IKurumBonusTanimlariTestBazli, MapReducerPayloads<IKurumBonusTanimlariTestBazli, {
    setIptalGosterme: string;
    setActiveRow: VwKurumbonustanimdetayDTO;
    setOpen: boolean;
}>>({
    name: "kurumBonusTanimlariTestBazli",
    initialState: {
        iptalGosterme: "E",
        activeRow: new VwKurumbonustanimdetayDTO(),
        open: false
    },
    reducers: {
        setIptalGosterme: (state, action) => {
            state.iptalGosterme = action.payload;
        },
        setActiveRow: (state, action) => {
            state.activeRow = action.payload;
        },
        setOpen: (state, action) => {
            state.open = action.payload;
        },
    },
});